import { GetServerSideProps } from 'next';

import { PageInformationFieldsFragment, PressReleaseFieldsFragment } from 'api/graphql-types';

import { IBasePageProps } from 'types/page';

interface INewsletterArchiveDetailPageProps extends IBasePageProps {
	html?: string;
	pageInformation?: PageInformationFieldsFragment;
	pressRelease?: PressReleaseFieldsFragment;
}

const NewsletterArchiveDetailPage = (props: INewsletterArchiveDetailPageProps): React.JSX.Element => {
	return (
		<div>
			<div dangerouslySetInnerHTML={{ __html: props.html || '' }} />
		</div>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	try {
		return {
			props: {}
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in news archive detail', error);

		return {
			notFound: true
		};
	}
};

export default NewsletterArchiveDetailPage;
